import React from "react";
import { Route, Routes } from "react-router-dom";
import { SCREEN_PATH } from "../../constants/global.constants";

import Reset from "../../views/auth-forms/ResetForm";
import EmailVerification from "../../views/auth-forms/EmailVerification";
import PrivacyPolicy from "../../views/privacy-policy/PrivacyPolicy";
import Home from "../../views/home/Home";
import AboutUs from "../../views/about-us/AboutUs";
import ContactUs from "../../views/contant-us/ContactUs";
import FAQ from "../../views/faq/FAQ";
import TermsAndConditions from "../../views/terms-and-conditions/TermsAndConditions";
import CountriesEncyclopedia from "../../views/countries-encyclopedia/CountriesEncyclopedia";
import CountriesEncyclopediaDetail from "../../views/countries-encyclopedia/CountriesEncyclopediaDetail";

const PublicRoute = ({ isAuthenticated }) => {
  return (
    <Routes>
      {!isAuthenticated && (
        <>
          <Route exact path={SCREEN_PATH.LOGIN} element={<Home />} />
          <Route exact path={SCREEN_PATH.HOME} element={<Home />} />
          <Route path={SCREEN_PATH.PRIVACY_POLICY} exact element={<PrivacyPolicy />} />
          <Route path={SCREEN_PATH.ABOUT_US} exact element={<AboutUs />} />
          <Route path={SCREEN_PATH.CONTACT_US} exact element={<ContactUs />} />
          <Route path={SCREEN_PATH.FAQ} exact element={<FAQ />} />
          <Route
            path={SCREEN_PATH.TERMS_AND_CONDITIONS}
            exact
            element={<TermsAndConditions />}
          />
          <Route
            path={SCREEN_PATH.COUNTRIES_ENCYCLOPEDIA}
            exact
            element={<CountriesEncyclopedia />}
          />
          <Route
            path={SCREEN_PATH.COUNTRY_ENCYCLOPEDIA_DETAIL}
            exact
            element={<CountriesEncyclopediaDetail />}
          />
        </>
      )}
      <Route path={SCREEN_PATH.RESET_PASSWORD} exact element={<Reset />} />
      <Route
        path={SCREEN_PATH.EMAIL_VERIFICATION}
        exact
        element={<EmailVerification />}
      />
    </Routes>
  );
};
export default PublicRoute;
